import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { medicalServiceEtlFieldService } from '../api/medical-service-etl-field.service';
import { AddButton } from 'components/ui';
import { MedicalServicesEtlFieldColumns } from '../medical-services-etl-transcodes';

export const MedicalServiceEtlFields = () => {
  const translationPrefix = 'pages.extra-field-transcode';
  const datagridRefresh = useRef(null);

  const { t } = useTranslation();

  const columns: GridColDef[] = MedicalServicesEtlFieldColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddButton to="new" prefix={translationPrefix} requireTenantAdmin />}>
      <EnhancedDataGrid
        columns={columns}
        service={medicalServiceEtlFieldService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
};

export default MedicalServiceEtlFields;
